import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";


interface StudentInfoData {
    date_creation: string;
    reading: number;
    speaking: number;
    listening: number;
    writing: number;
    grammar: number;
}


export const postStudentInfoCut = createAsyncThunk(
    "studentInfo/postStudentInfoCut",
    async ({studentId, groupId, data}: {
        studentId: string | undefined;
        groupId: string | undefined;
        data: StudentInfoData
    }, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);
            const response = await axios.post(`/api/groups/${groupId}/student-info/${studentId}/cut`,
                data,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );


            if (response.data.success) {

                return response.data;
            } else {
                // Если сервер вернул ошибку, обработайте ее здесь
                console.error("Произошла ошибка:", response.data.error);
                return thunkAPI.rejectWithValue(response.data.error);
            }
        } catch (error) {
            // Обработка ошибок
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
